<div class="row" *ngIf="error.existError">
  <div class="col-12" [ngClass]="setFontSize()">
    <div #alert class="alert alert-dismissible text-center" [ngClass]="typeError()">
      <h3><i class="icon fas fa-exclamation-triangle"></i> Atenção!</h3>
      <p *ngFor="let item of error.errorList" [innerHTML]="item"></p>
    </div>
  </div>
</div>
